import { render } from "./OrganizationAddModal.vue?vue&type=template&id=689fcd22"
import script from "./OrganizationAddModal.vue?vue&type=script&lang=js"
export * from "./OrganizationAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__